<div class="relative">
  <input
    #dateInput
    class="pr-10 caret-transparent"
    cslInput
    [inverted]="inverted"
    [id]="inputId"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabelledby || null"
    [attr.aria-describedby]="ariaDescribedby || null"
    [attr.aria-invalid]="ariaInvalid || null"
    [attr.aria-required]="required ? 'true' : null"
    [value]="value"
    (dateChange)="onDateChange($event)"
    [matDatepicker]="picker"
    [matDatepickerFilter]="datepickerFilter"
    [disabled]="isDisabled"
    placeholder="{{ placeholder }}"
    [min]="minDate"
    [max]="maxDate"
    (keydown)="onInputKeydown($event, picker)"
    (click)="onInputClick(picker)"
  />
  <mat-datepicker-toggle
    [for]="picker"
    class="absolute right-0 top-[50%] translate-y-[-50%] focus-within:outline-2 focus-within:outline-offset-2"
    aria-label="Open calendar"
  >
    <i
      matDatepickerToggleIcon
      [ngClass]="{ 'g-filter-gray-500': isDisabled }"
      class="g-filter-blue-900 block h-6 w-6 bg-[url(../assets/icons/calendar.svg)]"
    ></i>
  </mat-datepicker-toggle>
  <mat-datepicker #picker (closed)="onPickerClosed()" [calendarHeaderComponent]="DatepickerHeaderComponent" />
</div>
